import { TimelineItem } from '../../service/types'

const stripDiacritics = (s: string): string => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

export const filterTimelineItems = (items: TimelineItem[], query: string): TimelineItem[] => {
  const trimmed = stripDiacritics(query.trim().toLowerCase())
  if (!trimmed) return items

  return items.filter((item) => {
    if (item.type === 'receipt') {
      const customerName = stripDiacritics((item.data.customer?.name ?? '').toLowerCase())
      const receiptNumber = String(item.data.receiptNumber)
      return customerName.includes(trimmed) || receiptNumber.includes(trimmed)
    }
    const closingNumber = String(item.data.closingNumber)
    return closingNumber.includes(trimmed)
  })
}
